import Filters from "byzantine/src/filters";
import type { ReactLocalization } from "@fluent/react";
import type { FormattedBulkTemplate } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates/types";

export const getTemplateNetTotal = (
  template: FormattedBulkTemplate,
  options?: { hasDecimal?: false }
): string | null => {
  const creditCents = template.paymentData
    .filter((p) => p.transaction_type === "credit")
    .reduce((sum, p) => sum + p.amount, 0);
  const debitCents = template.paymentData
    .filter((p) => p.transaction_type === "debit")
    .reduce((sum, p) => sum + p.amount, 0);
  const netCents = debitCents - creditCents;
  if (netCents === 0) return null;
  const formatted = Filters.currency(Math.abs(netCents) as Cents, options);
  return netCents < 0 ? `-${formatted}` : formatted;
};

export const getTemplateAccountDisplay = (
  template: FormattedBulkTemplate
): string | null => {
  if (!template.institutionAccount) return null;
  return `${template.institutionAccount.getName()}-${template.institutionAccount.getMaskedNumber()}`;
};

/**
 * Formats a dollar total with payment count. When the total is $0.00,
 * returns just the count (e.g. "3 payments") instead of "$0.00 via 3 payments".
 */
export const formatPaymentTotal = (
  l10n: ReactLocalization,
  total: string | null,
  count: number
): string =>
  !total || total === "$0.00"
    ? l10n.getString("bulk-template-payment-count", { count })
    : `${total} ${l10n.getString("via-payments-cta", { total: count })}`;
